<template>
    <div>
        <div class="mb-2 text-xl font-bold">Choisissez votre emplacement et design</div>
        <div class="mb-2 font-bold">Emplacements et design</div>
        <div>
            <LocationItem
                v-for="(location, locationId) in product.locations"
                :key="locationId"
                :location-id="locationId"
                :toggle="locationToggled === locationId"
                :seleted="selectedLocations.includes(locationId)"
                :selected-locations="selectedLocations"
                @select-location="selectLocation"
                @update-customization="updateCustomization($event)"
                @toggle="toggleLocation($event)"
            />
        </div>
        <div class="mt-4 flex justify-between">
            <button
                type="button"
                class="flex border border-theme-blue bg-white px-4 py-2 uppercase text-theme-blue"
                @click="previousStep"
            >
                précédent
            </button>
            <button type="button" class="flex bg-theme-blue px-4 py-2 uppercase text-white" @click="nextStep">
                suivant
            </button>
        </div>
    </div>
</template>

<script>
import eventBus from "../../services/eventBus";
import { getLocationDetails } from "../../helpers/locationHelper";
import LocationItem from "./personalization/location-item.vue";

export default {
    name: "personalization",
    components: {
        LocationItem,
    },
    data() {
        return {
            locationToggled: "",
            selectedLocations: [],
            getLocationDetails,
        };
    },
    computed: {
        article() {
            return this.$store.getters["project/currentArticle"];
        },
        product() {
            return this.$store.getters["project/productConfiguration"];
        },
    },
    watch: {
        article: function (article) {
            this.selectedLocations = article.customization.map((custom) => custom.location);
            eventBus.emit("updateCarouselImage", "LOCATIONS");
        },
    },
    mounted() {
        this.selectColor();
    },
    created() {
        this.selectedLocations = this.article.customization.map((custom) => custom.location);
    },
    methods: {
        closeLocation() {
            this.locationToggled = null;
        },
        openLocation(index) {
            this.locationToggled = index;
        },
        selectLocation(index) {
            if (this.selectedLocations.includes(index)) {
                this.selectedLocations = this.selectedLocations.filter((value) => value !== index);
                this.closeLocation();
                this.deleteCustomization(index);
            } else {
                this.selectedLocations = [...this.selectedLocations, index];
                this.openLocation(index);
            }
        },
        toggleLocation(index) {
            this.locationToggled = this.locationToggled === index ? null : index;
        },
        deleteCustomization(location) {
            let customizationList = [...this.article.customization];

            customizationList = customizationList.filter((cstm) => cstm.location !== location);

            this.$store.dispatch("project/updateCurrentArticle", { prop: "customization", value: customizationList });
            this.$store.dispatch("project/removeAsset", location);
        },
        updateCustomization(customization) {
            const customizationList = [...this.article.customization];
            const customizationIdx = customizationList.findIndex((cstm) => cstm.location === customization.location);

            if (customizationIdx < 0) {
                customizationList.push(customization);
            } else {
                customizationList[customizationIdx] = customization;
            }

            if (!this.selectedLocations.includes(customization.location)) {
                this.selectedLocations = [...this.selectedLocations, customization.location];
            }

            this.$store.dispatch("project/updateCurrentArticle", { prop: "customization", value: customizationList });
        },
        nextStep() {
            eventBus.emit("setTab", 3);
        },
        previousStep() {
            eventBus.emit("setTab", 1);
        },
        selectColor() {
            eventBus.emit("updateCarouselImage", "LOCATIONS");
        },
    },
};
</script>

<style lang="scss">
.location {
    @apply mb-4 rounded border-2 border-transparent bg-gray-100;
    .content {
        @apply hidden;
    }
    &.toggle {
        .content {
            @apply block;
        }
    }
}
</style>
